import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { OurStorySectionContent } from './OurStorySectionContent';
import { useOurStorySectionController } from './OurStorySection.controllers';
import {
  OurStoryWrapper,
  StoryAssetsWrapper,
  GoldSquareBox,
  CurlBox,
  CircleBox,
  CenterAssetsWrapper,
  Pic1Box,
  Pic2Box,
  Pic3Box,
} from './OurStorySection.styles';

export const OurStorySectionDesktop = () => {
  const { containerRef, assetRef, curlRef } = useOurStorySectionController();
  return (
    <OurStoryWrapper ref={containerRef} paddingTop={13} paddingBottom={15}>
      <StoryAssetsWrapper ref={assetRef}>
        <GoldSquareBox>
          <CloudImage src="our-story/story/gold-sq.svg" width="100%" height="100%" optimization="aggressive" />
        </GoldSquareBox>
        <CircleBox>
          <CloudImage src="our-story/story/circle.svg" width="100%" height="100%" optimization="aggressive" />
        </CircleBox>
      </StoryAssetsWrapper>
      <CurlBox ref={curlRef}>
        <CloudImage resizeWidth={300} src="our-story/story/curl.svg" width="100%" height="100%" optimization="aggressive" />
      </CurlBox>
      <CenterAssetsWrapper>
        <Pic1Box>
          <CloudImage src="our-story/story/pic1.jpg" resizeWidth={290} width="100%" height="100%" optimization="aggressive" />
        </Pic1Box>
        <Pic2Box>
          <CloudImage src="our-story/story/pic2-v2.jpg" width="100%" height="100%" optimization="aggressive" />
        </Pic2Box>
      </CenterAssetsWrapper>
      <OurStorySectionContent />
      <CenterAssetsWrapper>
        <Pic3Box>
          <CloudImage resizeWidth={250} src="our-story/story/pic3-v2.jpg" width="100%" height="100%" optimization="aggressive" />
        </Pic3Box>
      </CenterAssetsWrapper>
    </OurStoryWrapper>
  );
};
